(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('OperazioneSearch', OperazioneSearch);

    OperazioneSearch.$inject = ['$resource'];

    function OperazioneSearch($resource) {
        var resourceUrl =  'api/_search/operaziones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
